import { render, staticRenderFns } from "./DelegationInfoCustomWebpageView.vue?vue&type=template&id=15ce53fb&scoped=true&"
import script from "./DelegationInfoCustomWebpageView.vue?vue&type=script&lang=js&"
export * from "./DelegationInfoCustomWebpageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce53fb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ce53fb')) {
      api.createRecord('15ce53fb', component.options)
    } else {
      api.reload('15ce53fb', component.options)
    }
    module.hot.accept("./DelegationInfoCustomWebpageView.vue?vue&type=template&id=15ce53fb&scoped=true&", function () {
      api.rerender('15ce53fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-info/DelegationInfoCustomWebpageView.vue"
export default component.exports